var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRealpriceSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Logo_Real_Price_Constraste",
    "data-name": "Logo / Logo_Real Price_Constraste",
    transform: "translate(-815.927 -1330.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotipo",
    transform: "translate(815.927 1330.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bg",
    d: "M-130.039-1512.9h55v55h-55Z",
    transform: "translate(130.039 1512.897)",
    fill: "#fafcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M-115.544-1498.811h40.872l-40.872,40.973Z",
    transform: "translate(122.709 1505.774)",
    fill: "#313234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M-101.867-1484.522h17.256l-17.256,17.156Z",
    transform: "translate(115.683 1498.475)",
    fill: "#fafcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M-64.154-1451.655l-4.642,4.642,14.33,14.632,4.945-4.844Z",
    transform: "translate(98.769 1481.729)",
    fill: "#313234"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRealpriceSm);
export default __webpack_public_path__ + "static/media/logo-realprice-sm.d91afff122a856c3f7f65f4fa531fa90.svg";
export { ForwardRef as ReactComponent };